import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreadCrumbComponent } from './bread-crumb.component';

//Material
import { MatToolbarModule } from '@angular/material';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { AppService } from '../app-service/app-service.service';

@NgModule({
  imports: [
    CommonModule,
    MatToolbarModule,
    NoopAnimationsModule
  ],
  declarations: [
    BreadCrumbComponent
  ],
  exports:[
    BreadCrumbComponent
  ]
})
export class BreadCrumbModule { }
